var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.213 42.5188C37.0286 42.675 36.7953 42.7546 36.5581 42.7424C36.3208 42.7303 36.0962 42.6272 35.9273 42.453C35.7584 42.2788 35.6572 42.0457 35.643 41.7984C35.6288 41.5511 35.7027 41.3071 35.8504 41.1131L42.7597 33.9087H19.9641C19.71 33.9087 19.4663 33.8042 19.2857 33.6178C19.1052 33.4315 19.0025 33.1784 19 32.9135C19 32.6469 19.1016 32.3912 19.2824 32.2027C19.4632 32.0142 19.7084 31.9082 19.9641 31.9082L42.758 31.9082L35.8488 24.7189C35.6717 24.5285 35.5727 24.2737 35.5727 24.0085C35.5727 23.7433 35.6717 23.4885 35.8488 23.2981C35.9377 23.2037 36.0437 23.1287 36.1607 23.0775C36.2777 23.0263 36.4032 22.9999 36.5301 22.9999C36.657 22.9999 36.7826 23.0263 36.8996 23.0775C37.0165 23.1287 37.1225 23.2037 37.2114 23.2981L45.7563 32.2048C45.9325 32.3926 46.0311 32.6449 46.0311 32.9076C46.0311 33.1704 45.9325 33.4227 45.7563 33.6105L37.213 42.5188Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    fill: "white",
    transform: "translate(19 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.9786d0cfa05068c4b5af0aa7fb11e26b.svg";
export { ForwardRef as ReactComponent };